export const VIEW_OTHER_RESOURCES = 'view_other_resources';
export const MANAGE_COMPANY_RESOURCES = 'manage_company_resources';
export const RESOURCES_REMOVE_FROM_PROJECT = 'resources_remove_from_project';
export const EDIT_OTHER_USERS_RECORDS = 'edit_other_users_records';
export const VIEW_OTHER_USERS_RECORDS = 'view_other_users_records';
export const RECORDS_VIEW_OTHER_USERS_RECORDS_DETAILED_INFORMATION =
  'records_view_other_users_records_detailed_information';
export const RECORDS_EDIT_OWN_RECORDS = 'records_edit_own_records';
export const RECORDS_CREATE_OTHER_USERS_RECORDS =
  'records_create_other_users_records';
export const RECORDS_APPROVE = 'records_approve';
export const EDIT_PERMISSIONS_OF_PROJECT = 'edit_permissions_of_project';
export const VIEW_OTHERS_FILE_PERMISSIONS = 'view_others_file_permissions';
export const BULLETIN_BOARD_ACCESS = 'bulletin_board_access';
export const BULLETIN_CREATE_EDIT_OWN = 'bulletin_board_create_edit_own';
export const BULLETIN_BOARD_EDIT_ALL = 'bulletin_board_edit_all';
export const BULLETIN_BOARD_SEND = 'bulletin_board_send_bulletin';
export const FORMS_ACCESS = 'forms_access';
// @deprecated — replaced by per-form-type keys (`forms_<type>_create_edit_own`,
// `forms_<type>_edit_all`). No runtime selector reads these anymore; the
// constants stay for legacy stored values and any consumer that still imports
// them. Use `buildFormTypePermissionKey(form, op)` from hasFormTypePermission.util.
export const FORMS_CREATE_EDIT_OWN = 'forms_create_edit_own';
export const FORMS_EDIT_ALL = 'forms_edit_all';
export const FORMS_SEND = 'forms_send';
export const FORMS_MANAGE_TEMPLATES = 'forms_manage_templates';
export const FORMS_DELETE = 'forms_delete';
export const FORMS_ORIENTATION_FORMS_MANAGE = 'forms_orientation_forms_manage';
export const FORMS_AUTOMATION_MANAGE = 'forms_automation_manage';
// Lets a user open the bulk edit tool. It confers no right to change any
// particular form, and none to sign anything: writing each form still goes
// through the ordinary edit permissions of its type, and placing a signature
// still needs that type's `sign_as_<role>` key. Bulk is a way to repeat what
// the user may already do one form at a time, never a way around it.
export const FORMS_MASS_EDIT_FORMS = 'forms_mass_edit_forms';

// Per-form-type permissions (9 types x 3 ops = 27 keys).
// Three types are gated by businessConfiguration.formTypes — the keys are
// always defined here; rendering and granting is conditional.
export const FORMS_WORKSITE_STATUS_DECLARATIONS_ACCESS =
  'forms_worksite_status_declarations_access';
export const FORMS_WORKSITE_STATUS_DECLARATIONS_CREATE_EDIT_OWN =
  'forms_worksite_status_declarations_create_edit_own';
export const FORMS_WORKSITE_STATUS_DECLARATIONS_EDIT_ALL =
  'forms_worksite_status_declarations_edit_all';
export const FORMS_TR_METERS_ACCESS = 'forms_tr_meters_access';
export const FORMS_TR_METERS_CREATE_EDIT_OWN =
  'forms_tr_meters_create_edit_own';
export const FORMS_TR_METERS_EDIT_ALL = 'forms_tr_meters_edit_all';
export const FORMS_SELF_SUPERVISION_MEMOS_ACCESS =
  'forms_self_supervision_memos_access';
export const FORMS_SELF_SUPERVISION_MEMOS_CREATE_EDIT_OWN =
  'forms_self_supervision_memos_create_edit_own';
export const FORMS_SELF_SUPERVISION_MEMOS_EDIT_ALL =
  'forms_self_supervision_memos_edit_all';
export const FORMS_SELF_HANDOVER_FORMS_ACCESS =
  'forms_self_handover_forms_access';
export const FORMS_SELF_HANDOVER_FORMS_CREATE_EDIT_OWN =
  'forms_self_handover_forms_create_edit_own';
export const FORMS_SELF_HANDOVER_FORMS_EDIT_ALL =
  'forms_self_handover_forms_edit_all';
export const FORMS_WORKSITE_JOURNALS_ACCESS = 'forms_worksite_journals_access';
export const FORMS_WORKSITE_JOURNALS_CREATE_EDIT_OWN =
  'forms_worksite_journals_create_edit_own';
export const FORMS_WORKSITE_JOURNALS_EDIT_ALL =
  'forms_worksite_journals_edit_all';
// Signer-slot permissions: the right to put a signature in one named slot of a
// worksite journal. Additive on top of the edit permissions above — signing is
// an edit, so create_edit_own/edit_all still has to allow the write.
// Worksite journals are the only type with named signer slots today; a second
// type gains them by listing its roles in FORM_TYPE_DEFINITIONS.
export const FORMS_WORKSITE_JOURNALS_SIGN_AS_FOREMAN_IN_CHARGE =
  'forms_worksite_journals_sign_as_foreman_in_charge';
export const FORMS_WORKSITE_JOURNALS_SIGN_AS_SUPERVISOR =
  'forms_worksite_journals_sign_as_supervisor';
export const FORMS_HOT_WORK_PERMIT_FORMS_ACCESS =
  'forms_hot_work_permit_forms_access';
export const FORMS_HOT_WORK_PERMIT_FORMS_CREATE_EDIT_OWN =
  'forms_hot_work_permit_forms_create_edit_own';
export const FORMS_HOT_WORK_PERMIT_FORMS_EDIT_ALL =
  'forms_hot_work_permit_forms_edit_all';
export const FORMS_WEEKLY_REVIEW_FORMS_ACCESS =
  'forms_weekly_review_forms_access';
export const FORMS_WEEKLY_REVIEW_FORMS_CREATE_EDIT_OWN =
  'forms_weekly_review_forms_create_edit_own';
export const FORMS_WEEKLY_REVIEW_FORMS_EDIT_ALL =
  'forms_weekly_review_forms_edit_all';
export const FORMS_PERSONNEL_LIFT_USAGE_PERMITS_ACCESS =
  'forms_personnel_lift_usage_permits_access';
export const FORMS_PERSONNEL_LIFT_USAGE_PERMITS_CREATE_EDIT_OWN =
  'forms_personnel_lift_usage_permits_create_edit_own';
export const FORMS_PERSONNEL_LIFT_USAGE_PERMITS_EDIT_ALL =
  'forms_personnel_lift_usage_permits_edit_all';
export const FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_ACCESS =
  'forms_substation_commissioning_inspection_reports_access';
export const FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_CREATE_EDIT_OWN =
  'forms_substation_commissioning_inspection_reports_create_edit_own';
export const FORMS_SUBSTATION_COMMISSIONING_INSPECTION_REPORTS_EDIT_ALL =
  'forms_substation_commissioning_inspection_reports_edit_all';

// Orientation-form perms (siblings of legacy `forms_orientation_forms_manage`).
// Access + create_edit_own are granted to basic employees; manage is admin-only.
export const FORMS_ORIENTATION_FORMS_ACCESS = 'forms_orientation_forms_access';
export const FORMS_ORIENTATION_FORMS_CREATE_EDIT_OWN =
  'forms_orientation_forms_create_edit_own';
// Deleting an orientation record is deliberately NOT covered by the generic
// `forms_delete`: orientation forms are compliance documents, so their delete
// right is granted on its own, like `forms_orientation_forms_manage`. Deletes
// stay soft (the backend only stamps `deletedAt`).
export const FORMS_ORIENTATION_FORMS_DELETE =
  'forms_orientation_forms_delete';

// Template-form perms — catch-all for form.type === 'template' and any
// future unmapped form type.
export const FORMS_TEMPLATE_FORMS_ACCESS = 'forms_template_forms_access';
export const FORMS_TEMPLATE_FORMS_CREATE_EDIT_OWN =
  'forms_template_forms_create_edit_own';
export const FORMS_TEMPLATE_FORMS_EDIT_ALL = 'forms_template_forms_edit_all';

export const GALLERY_ACCESS = 'gallery_access';
export const GALLERY_VIEW_OTHER_USERS_IMAGES =
  'gallery_view_other_users_images';
export const GALLERY_EDIT_OTHER_USERS_IMAGES =
  'gallery_edit_other_users_images';
export const GALLERY_VIEW_MEDIA_ADDER_INFO = 'gallery_view_media_adder_info';
export const GALLERY_MANAGE_FLOORPLANS = 'gallery_manage_floorplans';

export const EXPENSE_TRACKING_ACCESS = 'expense_tracking_access';
export const PROJECT_ID_CARD_EDIT = 'project_id_card_edit';
export const VIEW_SUBPROJECTS = 'view_subprojects'; //display subprojects in projects list even if user has not joined them.
export const RECORDS_SEND_TO_APPROVAL = 'records_send_to_approval';
export const PROJECT_APPROVALS_MANAGE = 'project_approvals_manage'; // fix
export const RECORDS_CHECK_BILLED_TIMES = 'records_check_billed_times';
export const RECORDS_CHECK_CLOCKED_TIMES = 'records_check_clocked_times';
export const RECORDS_ABSENCE_CREATE = 'records_absence_create';
export const PROJECT_MAP_ACCESS = 'project_map_access';
export const PROJECT_EDIT = 'project_edit';
export const PROJECT_STATUS_EDIT = 'project_status_edit';
export const PROJECT_TIMELINES_EDIT = 'project_timelines_edit';
export const PROJECT_TIMELINES_VIEW = 'project_timelines_view';
export const PROJECT_TIMELINES_ASSIGNMENTS_BASED_VALUES_VIEW =
  'project_timelines_assignments_based_values_view';
export const PROJECT_TIMELINES_ASSIGNMENT_CONNECTIONS_MANAGE =
  'project_timelines_assignment_connections_manage';
export const PROJECT_BANK_ACCESS = 'project_bank_access';
export const PROJECT_BANK_DELETE = 'project_bank_delete'; // Named differently for backwards compatibility (was in use before separating own and any)
export const PROJECT_BANK_DELETE_OWN = 'project_bank_delete_own';
export const PROJECT_BANK_EDIT = 'project_bank_edit'; // Named differently for backwards compatibility (was in use before separating own and any)
export const PROJECT_BANK_EDIT_OWN = 'project_bank_edit_own';
export const PROJECT_BANK_MOVE_ANY = 'project_bank_move_any';
export const PROJECT_BANK_MOVE_OWN = 'project_bank_move_own';
export const PROJECT_BANK_TILAAJAVASTUU_DOCUMENTS_VIEW =
  'project_bank_tilaajavastuu_documents_view';
export const PROJECT_BANK_TILAAJAVASTUU_DOCUMENTS_MANAGE =
  'project_bank_tilaajavastuu_documents_manage';
export const PROJECT_BANK_PRIVATE_FOLDER_ACCESS =
  'project_bank_private_folder_access';
export const PROJECT_CREATE = 'project_create';
export const ORIENTATION_QUIZ_MANAGE = 'orientation_quiz_manage';
export const COMPETENCIES_VIEW_OTHER_USER_COMPETENCIES =
  'competencies_view_other_user_competencies';

export const REPORTS_GENERATE_ORIENTATION_REPORT =
  'reports_generate_orientation_report';

export const REPORTS_GENERATE_EMPLOYEE_REPORT =
  'reports_generate_employee_report';

export const REPORTS_GENERATE_PROJECT_LIST_REPORT =
  'reports_generate_project_list_report';

export const DEFECTS_DEFECT_LISTS_ACCESS = 'defects_defect_lists_access';
export const DEFECTS_DEFECT_LISTS_VIEW = 'defects_defect_lists_view';
export const DEFECTS_DEFECT_LISTS_CREATE = 'defects_defect_lists_create';
export const DEFECTS_DEFECTS_EDIT = 'defects_defects_edit';

export const FIRESTOP_DOCUMENTATION_ACCESS = 'firestop_documentation_access';

export const FILINGS_MANAGE = 'filings_manage';
export const FILINGS_SEND = 'filings_send';
export const ORIENTATION_QUIZ_IGNORE_ORIENTATION_REQUIREMENT =
  'orientation_quiz_ignore_orientation_requirement';

export const RECORDS_CREATE = 'records_create';

export const AREAPLAN_VIEW = 'areaplan_view';
export const AREAPLAN_EDIT = 'areaplan_edit';
export const ORGANIZATION_CHART_VIEW = 'organization_chart_view';
export const ORGANIZATION_CHART_EMPLOYEE_INFO_VIEW =
  'organization_chart_employee_info_view';
export const ORGANIZATION_CHART_MANAGE_ORGANIZATIONS =
  'organization_chart_manage_organizations';

// export const DEFECTS_DEFECTS_APPROVE = 'defects_defects_approve';

//below permissions currently only used in frontend logic
export const PROJECT_BANK_VIEW_OTHER_USERS_DATA =
  'project_bank_view_other_users_data';
export const UPLOAD_PICTURE = 'upload_picture';
export const UPLOAD_FILE = 'upload_file';

export const PROJECT_INVITE = 'project_invite';
export const WORK_CALENDAR_ACCESS = 'work_calendar_access';
export const EMPLOYEE_FEATURES_ACCESS = 'employee_features_access';
// end of permissions used only in frontend logic

// employer level permissions
export const RECORDS_ALLOW_MULTIPLE_CLOCK_IN_OWN_PROJECTS =
  'records_allow_multiple_clock_in_own_projects';

export const WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS =
  'work_calendar_view_all_own_business_records';

export const WORK_CALENDAR_EDIT_ALL_OWN_BUSINESS_RECORDS =
  'work_calendar_edit_all_own_business_records';

export const WORK_CALENDAR_WORK_TIME_SALDOS_VIEW =
  'work_calendar_work_time_saldos_view';

export const PROJECTS_OWN_AUTOMATIC_JOIN = 'projects_own_automatic_join';

export const PROJECTS_OWN_ARCHIVED_PROJECTS_VIEW =
  'projects_own_archived_projects_view';

export const SUBCONTRACTORS_RECORDS_VIEW = 'subcontractors_records_view';

export const RESOURCES_EDIT_SALARIES = 'resources_edit_salaries';

export const RESOURCES_COMPETENCIES_MANAGE = 'resources_competencies_manage';
export const RESOURCES_ADD_EMPLOYEES_TO_PROJECTS =
  'resources_add_employees_to_projects';

export const SALARIES_TRANSFER_SEND = 'salaries_transfer_send';
export const SALARIES_TYPES_EDIT = 'salaries_types_edit';

export const GALLERY_ADD_PICTURES_TO_ROOT = 'gallery_add_pictures_to_root';

export const CUSTOMER_REGISTRY_ACCESS = 'customer_registry_access';

export const CONTACTS_VIEW = 'contacts_view';

export const CONTACTS_MANAGE = 'contacts_manage';

export const DEVICES_MANAGE = 'devices_manage';

export const CHATBOT_ACCESS = 'chatbot_access';

export const PROJECT_EMAIL_READ = 'project_email_read';
export const PROJECT_EMAIL_SEND = 'project_email_send';
export const PROJECT_EMAIL_SEE_READ_BY_OTHERS =
  'project_email_see_read_by_others';

export const PROJECT_CHAT_ACCESS = 'project_chat_access';
export const PROJECT_CHAT_RECORD_VIDEO_CHAT = 'project_chat_record_video_chat';
export const PROJECT_CHAT_VIEW_RECORDINGS = 'project_chat_view_recordings';
export const PROJECT_CHAT_MEETINGS_MANAGE = 'project_chat_meetings_manage';

export const RENOLOG_ACCESS = 'renolog_access';
export const RENOLOG_ORDER = 'renolog_order';
export const RENOLOG_MANAGE = 'renolog_manage';
export const RENOLOG_SHARE_ACCESS = 'renolog_share_access';

export const ACTIVITY_LOG_VIEW = 'activity_log_view';
